module.exports = __webpack_public_path__ + "fonts/6d380a1.ttf";